import React, { createContext, FC, useState } from 'react';

import { arenaSegmentService } from '@services/cstool';

const useArenaSegmentContextValue = () => {
  const [environment, setEnvironment] = useState<string>();
  const [segmentHistoryData, setSegmentHistoryData] = useState<any[]>();
  const [segmentsData, setSegmentsData] = useState<any>();

  const loadSegmemntHistory = async () => {
    const res = await arenaSegmentService.getArenaSegmentHistory(environment);
    const { ok, data } = res;
    if (ok) {
      setSegmentHistoryData(data ?? []);
    }
  };

  const loadSegmentData = async (env: string | undefined, blueVer: string | undefined) => {
    if (!env || !blueVer) {
      setSegmentsData([]);
      return;
    }
    const res = await arenaSegmentService.getArenaSegments({
      environment: env,
      blueprintVersion: blueVer,
    });
    const { ok, data } = res;
    if (ok) {
      setSegmentsData(data ?? []);
    }
  };

  return {
    environment,
    setEnvironment,
    segmentHistoryData,
    loadSegmemntHistory,
    segmentsData,
    loadSegmentData,
  };
};

export type ArenaSegmentContext = ReturnType<typeof useArenaSegmentContextValue>;

const arenaSegmentContext = createContext<ArenaSegmentContext | null>(null);

export const ArenaSegmentProvider: FC = ({ children }) => {
  const value = useArenaSegmentContextValue();
  return <arenaSegmentContext.Provider value={value}>{children}</arenaSegmentContext.Provider>;
};

export const useArenaSegmentContext = () => {
  const context = React.useContext(arenaSegmentContext);
  if (!context) {
    throw new Error('useArenaSegmentContext must be used within a ArenaSegmentProvider');
  }
  return context;
};

export default ArenaSegmentProvider;
